module.exports = __webpack_public_path__ + "c03a261ac0cd8106fe947a1a7b8464d2.png";